import { tabProps } from "@/utils/globalPropsTypes";
import { Button, ColorPicker, Form, Input, InputNumber, Space, Switch } from "antd";
import React from "react";
import { AiOutlineMinusCircle, AiOutlinePlus } from "react-icons/ai";

function AxisTab({ editItem = {} }) {
  const { component } = editItem;
  return (
    <>
      {["bar", "line"].includes(component) && (
        <Form.List name="threshold" initialValue={[{ value: "0", color: "#fff000" }]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: "flex", marginBottom: 8 }} align="center">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="d-flex gap-3">
                      <Form.Item name={[name, "color"]} getValueFromEvent={(_, color) => color}>
                        <ColorPicker />
                      </Form.Item>
                      <Form.Item name={[name, "color"]}>
                        <Input placeholder="Color" />
                      </Form.Item>
                    </div>
                    <Form.Item {...restField} name={[name, "value"]}>
                      <InputNumber placeholder="value" className="w-100" />
                    </Form.Item>

                    {/* <Form.Item {...restField} name={[name, "icon"]}>
                      <Select
                        style={{ width: "100%" }}
                        size="large"
                        showSearch={true}
                        filterOption={(input, option) => {
                          setIconOptions(allIconOptions);
                          return (option?.value ?? "").toLowerCase().includes(input.toLowerCase());
                        }}
                        placeholder="Select Icon"
                        options={iconOptions}
                        popupClassName="customSelect"
                        virtual={false}
                        onPopupScroll={popupScroll}
                        rules={[
                          {
                            required: true,
                            message: "Please Select a Tab Icon",
                          },
                        ]}
                      />
                    </Form.Item> */}
                  </div>
                  <div style={{ marginBottom: "15px" }}>
                    <AiOutlineMinusCircle onClick={() => remove(name)} />
                  </div>
                </Space>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add({})} block icon={<AiOutlinePlus />}>
                  Add Level
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      )}

      {/* {["bar", "line"].includes(component) && (
        <>
          <Form.Item name="dateFormat" label="Select Date Format">
            <Select
              placeholder="Select Date Format"
              options={[
                "DD MMM YYYY, hh:mm TT",
                "DD MM YYYY, hh:mm TT",
                "D MMM YYYY, hh:mm TT",
                "D MM YYYY, hh:mm TT",
              ].map((item) => ({ label: item, value: item }))}
            />
          </Form.Item>
        </>
      )} */}

      <Form.Item
        layout="horizontal"
        initialValue={true}
        label="Show Grid Lines"
        name="gridLine"
        colon={false}
        className="right-label mb-0"
      >
        <Switch />
      </Form.Item>

      <Form.Item
        layout="horizontal"
        initialValue={true}
        label="Show Axis Lines"
        name="verticalLine"
        colon={false}
        className="right-label mb-0"
      >
        <Switch />
      </Form.Item>
    </>
  );
}

export default AxisTab;

AxisTab.propTypes = tabProps;
